<template>
  <v-dialog v-model="dialog" max-width="800" persistent scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="cadpro"
        :icon="!isMobile()"
        color="info"
        v-on="on"
        v-bind="attrs"
        title="Editar cadpro"
        :rounded="isMobile()"
        :block="isMobile()"
        :outlined="isMobile()"
      >
        <v-icon :left="isMobile()">mdi-pencil</v-icon>
        <span v-if="isMobile()">Editar</span>
      </v-btn>
      <v-btn
        v-else
        :block="isMobile()"
        rounded
        color="info"
        :height="isMobile() ? 35 : 30"
        v-on="on"
        v-bind="attrs"
      >
        <v-icon size="18">mdi-plus</v-icon> Adicionar Cadpro</v-btn
      >
    </template>
    <v-card :loading="loading">
      <v-card-title class="font-weight-bold">
        {{ cadpro ? "Editar" : "Adicionar" }} Cadpro</v-card-title
      >
      <v-card-subtitle 
        >{{ cliente.nome }} - {{ cliente.matricula }}</v-card-subtitle
      >
      <v-card-text>
        <v-form ref="form">
          <v-text-field
            label="Nº Cadpro"
            v-model="dadoscadpro.cadpro"
            :rules="[(v) => !!v || 'Informe o número do CadPro']"
            :disabled="editar"
          ></v-text-field>
          <v-text-field
            label="Descrição"
            v-model="dadoscadpro.descricao"
            :rules="[(v) => !!v || 'Informe a descrição do CadPro']"
          ></v-text-field>

          <v-row dense>
            <v-col xl="4" lg="4" md="4" cols="12">
              <v-text-field
                label="Tamanho Imóvel"
                v-mask="maskTamanhoImovel"
                v-model="dadoscadpro.tamanhoimovel"
              ></v-text-field>
            </v-col>
            <v-col xl="4" lg="4" md="4" cols="12">
              <v-text-field
                label="Emissão"
                type="date"
                v-model="dadoscadpro.emissao"
              ></v-text-field>
            </v-col>
            <v-col xl="4" lg="4" md="4" cols="12">
              <v-text-field
                label="Vencimento"
                type="date"
                v-model="dadoscadpro.vcto"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-text-field
            label="Incra"
            v-model="dadoscadpro.incra"
          ></v-text-field>

          <v-row dense>
            <v-col xl="6" lg="6" md="6" cols="12">
              <cmb-municipios />
            </v-col>
            <v-col xl="6" lg="6" md="6" cols="12">
              <cmb-localidades />
            </v-col>
          </v-row>

          <v-text-field
            label="Endereço"
            v-model="dadoscadpro.endereco"
            :rules="[(v) => !!v || 'Informe o endereço']"
          ></v-text-field>

          <v-row dense>
            <v-col xl="9" lg="9" md="9" cols="12">
              <v-text-field
                label="Bairro"
                v-model="dadoscadpro.bairro"
                :rules="[(v) => !!v || 'Informe o bairro']"
              ></v-text-field>
            </v-col>
            <v-col xl="3" lg="3" md="3" cols="12">
              <v-text-field
                label="CEP"
                v-model="dadoscadpro.cep"
                :rules="[(v) => !!v || 'Informe o CEP']"
                v-mask="'########'"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-btn
            class="mt-4"
            block
            color="success"
            rounded
            @click="salvarCadPro()"
            :loading="salvando"
            >Salvar Cadpro</v-btn
          >
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text rounded @click="dialog = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import CmbMunicipios from "../locais/CmbMunicipios.vue";
import CmbLocalidades from "../locais/CmbLocalidades.vue";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

export default {
  watch: {
    dialog: async function (open) {
      if (open) {
        this.editar = false;
        this.$store.commit("locais/resetState");
        await this.getMunicipios();
        this.setMunicSelec(0);
        this.setLocalidSelec(0);

        if (this.cadpro) {
          this.editar = true;
          this.dadoscadpro.id = this.cadpro.id;
          this.dadoscadpro.matricula = this.cadpro.matricula;
          this.dadoscadpro.cadpro = this.cadpro.nrcadpro;
          this.dadoscadpro.descricao = this.cadpro.descricao;
          this.dadoscadpro.tamanhoimovel = this.cadpro.tamanhoimovel;
          this.dadoscadpro.emissao = this.cadpro.emissao;
          this.dadoscadpro.vcto = this.cadpro.vcto;
          this.dadoscadpro.incra = this.cadpro.incra;
          this.dadoscadpro.codmunicipio = this.cadpro.codmunicipio;
          this.dadoscadpro.codlocalidade = this.cadpro.codlocalidade;
          this.dadoscadpro.endereco = this.cadpro.endereco;
          this.dadoscadpro.bairro = this.cadpro.bairro;
          this.dadoscadpro.cep = this.cadpro.cep;

          this.setMunicSelec(this.cadpro.codmunicipio);
          await this.getLocalidades();
          this.setLocalidSelec(this.cadpro.codlocalidade);
        } else if (this.$refs.form) this.$refs.form.reset();

        this.loading = false;
      }
    },
    localidSelec: function (value) {
      this.dadoscadpro.cep = "";
      if (value > 0) {
        if (
          this.getLocalidadeSelecionada() &&
          this.getLocalidadeSelecionada().cep > 0
        )
          this.dadoscadpro.cep = this.getLocalidadeSelecionada().cep;
      }
    },
  },
  components: { CmbMunicipios, CmbLocalidades },
  props: {
    cliente: Object,
    cadpro: Object,
  },
  computed: {
    ...mapState("usuario", ["usuarioLogado"]),
    ...mapState("locais", ["localidSelec", "municSelec"]),    
  },
  data: () => ({
    editar: false,
    loading: true,
    dialog: false,
    dadoscadpro: {
      id: 0,
      cadpro: "",
      descricao: "",
      tamanhoimovel: 0.0,
      emissao: "",
      vcto: "",
      incra: "",
      codmunicipio: 0,
      codlocalidade: 0,
      endereco: "",
      bairro: "",
      cep: "",
      codusuario: 0,
      matricula: 0,
    },
    salvando: false,
    maskTamanhoImovel: createNumberMask({
      prefix: "",
      includeThousandsSeparator: false,
      decimalSymbol: ",",
      allowLeadingZeroes: true,
      allowDecimal: true,
    }),
  }),
  methods: {    
    ...mapActions("locais", ["getMunicipios", "getLocalidades"]),
    ...mapActions("clientes", ["getCadpros"]),
    ...mapMutations("locais", ["setMunicSelec", "setLocalidSelec"]),
    ...mapGetters("locais", ["getLocalidadeSelecionada"]),
    isMobile() {
      return this.$mq == "sm";
    },
    async salvarCadPro() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.salvando = true;

      this.dadoscadpro.matricula = this.cliente.matricula;
      this.dadoscadpro.codmunicipio = this.municSelec;
      this.dadoscadpro.codlocalidade = this.localidSelec;
      this.dadoscadpro.codusuario = this.usuarioLogado.codigo;
      this.dadoscadpro.cep = parseInt(this.dadoscadpro.cep);

      await axios
        .post(
          "/nutricao-animal/cadpro/salvar-cadpro",
          JSON.stringify(this.dadoscadpro)
        )
        .then(async (res) => {
          if (res.data.success) {
            await this.getCadpros({ pesquisa: this.cliente.matricula });
            this.$toasted.success(res.data.msg);

            this.dialog = false;
          } else this.$toasted.error(res.data.msg);
        })
        .catch((e) => this.$toasted.error(e));
      this.salvando = false;
    },
  },
};
</script>

<style>
</style>